import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import "./ImageSelectorComponent.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, A11y, Keyboard } from "swiper/modules";
const imagesData = [
  { name: "כל המיזמים", filterKey: "", path: "/images/allFields.svg" },
  { name: "תחום האנרגיה", filterKey: "אנרגיה", path: "/images/energy.svg" },
  { name: "תחום התחבורה", filterKey: "תחבורה", path: "/images/transport.svg" },
  { name: "תחומים אחרים", filterKey: "אחרים", path: "/images/other.svg" },
];

export default function ImageSelectorComponent({ onChangeFilter }: { onChangeFilter: any }) {
  const [selected, setSelected] = useState<string>("");

  const onChange = (filterKey: string) => {
    onChangeFilter(filterKey);
    setSelected(filterKey);
  };

  useEffect(() => {
    document.querySelector(".swiper-button-next")?.setAttribute("aria-label", "כפתור הבא");
    document.querySelector(".swiper-button-prev")?.setAttribute("aria-label", "כפתור קודם");
  }, []);

  console.log("Avocaco");

  return (
    <Swiper
      modules={[Navigation, A11y, Keyboard]}
      navigation
      role="region"
      aria-label="סינון מיזמים לפי תחום"
      keyboard={{
        enabled: true,
        onlyInViewport: true,
      }}
      style={{ width: "100%", minHeight: "1px", marginTop: "30px" }}
      centeredSlides={false}
      centerInsufficientSlides={true}
      spaceBetween={20}
      onSwiper={(swiper: any) => (swiper.current = swiper)}
      onSlideChange={(swiper: any) => {
        // only on mobile (where slidesPerView === 1)
        if (swiper.params.slidesPerView === 1) {
          onChange(imagesData[swiper.activeIndex].filterKey);
        }
      }}
      breakpoints={{
        320: {
          slidesPerView: 1,
        },
        600: {
          slidesPerView: 2,
        },
        1100: {
          slidesPerView: 3,
        },
        1450: {
          slidesPerView: 4,
        },
      }}
    >
      {imagesData.map((imgData, index) => (
        <SwiperSlide key={imgData.filterKey}>
          <Box
            role="button"
            tabIndex={0}
            aria-pressed={selected === imgData.filterKey}
            onClick={() => onChange(imgData.filterKey)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onChange(imgData.filterKey);
              }
            }}
            sx={{
              fontFamily: "Heebo",
              borderBottom: selected === imgData.filterKey ? "5px solid #1293FE" : "3px solid transparent",
              paddingBottom: "4px",
              textAlign: "center",
              cursor: "pointer",
              outline: "none",
              "&:focus-visible": {
                outline: "3px solid #1293FE",
                outlineOffset: "4px",
              },
            }}
          >
            <img src={imgData.path} alt="" className={`image-item ${selected === imgData.filterKey ? "selected" : ""}`} />
            <div className={`image-text ${selected === imgData.filterKey ? "selected-text" : ""}`}>{imgData.name}</div>
          </Box>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
